import { useContextState } from "../../../../../../../../../../hooks/theme"



const useStyles = () => {
    const { colors } = useContextState()
    return {
        title: {
            fontWeight: 'bold'
        },
        text: {
            color: colors.color13,
            textAlign: 'center',
        },
        noActivities: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            padding: 2,
            '& .MuiSvgIcon-root': {
                color: colors.color13
            },
            marginTop:'-24px'
        },
        optionsContainer: {
            padding: '0px 20px',
            height:'100%',
            maxHeight:'820px',
            flexGrow: 1,
        },
        activityiesContainer: {
            display:'flex',
            flexDirection:'column',
            gap:1,
            maxHeight: '95%',
            overflow: 'auto',
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": {
              display: "none",
            }
        },
        activityContainer: (error:boolean) => ({
            border: error ? `1px solid ${colors.color19}`: `1px solid ${colors.color13}`,
            padding:'8px 16px',
            display:'flex',
            borderRadius:'8px',
            alignItems:'center',
            gap:1,
            color:error ? colors.color19: colors.color13
        }),
        smallIcon:{
            /* display:'flex',
            alignItems:'center', */
            '& .MuiSvgIcon-root':{
                fontSize: '1rem',
                marginBottom: '-3px'
            }
        },
        index:{
            width:'9%',
            '& .MuiTypography-root':{
                fontSize:'28px'
            }, 
            justifyItems:'center'
        },
        information: {
            width:'69%',
            '& .fontBold':{
                fontWeight:'bold'
            },
            '& .MuiTypography-root':{
                fontSize:'14px'
            },
        },
        options: (error:boolean) => ({
            width:'19%',
            '& .MuiSvgIcon-root':{
                color: error ? colors.color19: colors.color13
            }
        }),
    }
}

export { useStyles }
